import Vue from 'vue';
import Vue2LeafletGoogleMutant from '@/components/Vue2LeafletGoogleMutant.vue';

Vue.component('l-google-tile-layer', Vue2LeafletGoogleMutant);
